import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ec7bca7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-dollar-sign me-2" }),
  /*#__PURE__*/_createTextVNode("ข้อมูลงบประมาณ ")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card-footer d-flex justify-content-end" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chevron-right ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BudgetFormComponent = _resolveComponent("BudgetFormComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_BudgetFormComponent, {
        ref: "budgetForm",
        budgets: _ctx.budgets,
        onValidated: _ctx.validated
      }, null, 8, ["budgets", "onValidated"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextClick && _ctx.nextClick(...args)))
      }, [
        _createTextVNode(" ถัดไป"),
        _hoisted_5
      ])
    ])
  ]))
}